import { Col, Container, Row } from "react-bootstrap";
import { X } from "react-bootstrap-icons";
import "./payResultStyle.css";
import { Link } from "react-router-dom";

export default function Failed() {
  return (
    <div className="bg-fail-style">
      <Container className="pt-5">
        <Row className="d-flex align-items-center justify-content-center bg-white mt-5">
          <Col className="d-flex align-items-center justify-content-center clmn-style m-5">
            <div
              className="border border-secondary rounded-circle
                        d-flex align-items-center justify-content-center"
            >
              <X color="red" size={60} />
            </div>
            <h3 className="mt-3 text-danger">خطا در تراکنش </h3>
            <p>خطایی در انجام تراکنش رخ داده است</p>
          </Col>
        </Row>
      </Container>
      <div className="d-flex align-items-center justify-content-center mt-3">
        <Link to="/" className="btn btn-success mx-1">
          صفحه اصلی
        </Link>
        <Link
          to="https://panel.avaex.ir"
          target="_blank"
          className="btn btn-success mx-1"
        >
          API پنل
        </Link>
      </div>
    </div>
  );
}
